import { GlAvatarLink, GlIcon, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { __ } from '~/locale';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { getByVersionKey, isGitLabMaintainedItem } from 'ee/ai/catalog/utils';
export default {
    name: 'AiCatalogItemUserAttribution',
    components: {
        GlAvatarLink,
        GlIcon,
        GlSprintf,
        TimeAgoTooltip
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        versionKey: {
            type: String,
            required: true
        },
        authorClasses: {
            type: String,
            required: false,
            default: 'gl-font-bold gl-text-default'
        }
    },
    computed: {
        activeVersion () {
            return getByVersionKey(this.item, this.versionKey);
        },
        isFirstVersion () {
            return this.activeVersion?.createdAt === this.item.createdAt;
        },
        createdBy () {
            return this.activeVersion?.createdBy;
        },
        isGitLabMaintained () {
            return isGitLabMaintainedItem(this.item);
        },
        authorName () {
            return this.isGitLabMaintained ? __('GitLab') : this.createdBy?.name ?? __('Unknown');
        },
        hasUserLink () {
            return Boolean(this.createdBy) && !this.isGitLabMaintained;
        },
        userId () {
            return getIdFromGraphQLId(this.createdBy?.id);
        },
        actionMessage () {
            if (this.time) {
                return this.isFirstVersion ? __('Created %{timeAgo} by %{author}') : __('Updated %{timeAgo} by %{author}');
            }
            return this.isFirstVersion ? __('Created by %{author}') : __('Updated by %{author}');
        },
        time () {
            return this.activeVersion?.createdAt;
        },
        testId () {
            return this.isFirstVersion ? 'created-by' : 'modified-by';
        }
    }
};
